import { createFileRoute, notFound } from '@tanstack/react-router'
import { LegalPage } from '../../components/LegalPage'
import { legalDoc } from '../../content/legal'
import { getDict, parseLocale } from '../../i18n'
import { seoHead } from '../../lib/seo'
import { SITE_ORIGIN } from '../../lib/site'

export const Route = createFileRoute('/{-$locale}/terms')({
  beforeLoad: ({ params }) => {
    if (!parseLocale(params.locale)) throw notFound()
  },
  head: ({ params }) => {
    const locale = parseLocale(params.locale) ?? 'ja'
    const { doc } = legalDoc('terms', locale)
    return seoHead({
      origin: SITE_ORIGIN,
      locale,
      path: '/terms',
      title: getDict(locale).meta.termsTitle,
      description: doc.intro,
    })
  },
  component: () => <LegalPage kind="terms" />,
})
